module.exports = __webpack_public_path__ + "img/code.2695e04d.png";